<div class="marker__content">
  <!-- Date time attribute is used within RecordingPlaybackTabService -->
  <ftr-date
    [date]="startTime"
    [format]="dateFormats.Time"
    [attr.data-datetime]="startTime"
    class="marker__content-time"
  ></ftr-date>
  <div class="marker__content-container">
    <span class="marker__content-title"> Loading text </span>
  </div>
</div>
<!-- Date time attribute is used within RecordingPlaybackTabService -->
@for (widths of loadingRemarkPlaceholderWidths; track widths; let first = $first) {
  <div [attr.data-datetime]="startTime" class="marker__loading">
    <!-- We don't ever hide this on small screens because speakers and remarks stack -->
    <div [ngClass]="widths.speaker || first ? 'marker__loading-speaker' : 'marker__loading-speaker__hide'">&nbsp;</div>
    <div [style.width]="widths.content">&nbsp;</div>
  </div>
}
